import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {mappedBooleanDisplayValue} from '../utils';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getGroupSettingDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateGroupSetting =
    currTemplateLinePlotSettings?.useRunsTableGroupingInPanels;
  const newTemplateGroupSetting =
    currWorkspaceLinePlotSettings?.useRunsTableGroupingInPanels ??
    DEFAULT_LINE_PLOT_SETTINGS.useRunsTableGroupingInPanels;

  return {
    groupTitle: 'Grouping',
    label: 'Use grouping in charts',
    field: 'useRunsTableGroupingInPanels' as keyof LinePlotTemplateSettings,
    currValue: currTemplateGroupSetting,
    currDisplayValue:
      currTemplateGroupSetting == null
        ? undefined
        : mappedBooleanDisplayValue(currTemplateGroupSetting),
    newValue: newTemplateGroupSetting,
    newDisplayValue: mappedBooleanDisplayValue(newTemplateGroupSetting),
  };
};
